/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IFormChangeModalController extends IBaseModalControllerScope {
        formSection: Wars.Domain.Model.FormSection;
        form: Wars.Domain.Model.Form;
        processConfigId: string;
        processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        forms: Wars.Domain.Model.Form[];
        steps: Wars.Domain.Model.FormStep[];
        model: FormChangeModel;
        destinationFormChanged(): void;
        saveChanges(): void;
    }

    export class FormChangeModel {
        destinationForm: Wars.Domain.Model.Form;
        destinationStep: Wars.Domain.Model.FormStep;
    }

    export class FormChangeModalController extends BaseModalController {
        scope: IFormChangeModalController;

        constructor(
            $scope: IFormChangeModalController,
            formSection: Wars.Domain.Model.FormSection,
            form: Wars.Domain.Model.Form,
            processConfigId: string,
            private formService: services.FormService,
            private processConfigurationService: services.ProcessConfigurationService,
            close: any)
        {
            super($scope, close);
            this.scope = $scope;

            this.scope.form = form;
            this.scope.formSection = formSection;
            this.scope.processConfigId = processConfigId;
            this.scope.destinationFormChanged = () => this.destinationFormChanged();
            this.scope.saveChanges = () => this.saveChanges();


            this.processConfigurationService.getExpandFields(this.scope.processConfigId).then(
                (processConfig) => {
                    this.scope.processConfiguration = processConfig;
                    this.scope.forms = Enumerable.from(this.scope.processConfiguration.myForms)
                        .where(i => i.formType === Wars.Domain.Model.Codes.Enums.FormType.MultiStep ||
                            i.formType === Wars.Domain.Model.Codes.Enums.FormType.SinglePage)
                        .toArray();
                });
            

            this.scope.model = new FormChangeModel();
        }

        private destinationFormChanged() {
            if (this.scope.model.destinationForm === undefined || this.scope.model.destinationForm === null) {
                this.scope.steps = [];
            } else {
                this.scope.steps = this.scope.model.destinationForm.mySteps;
            }
        }

        private saveChanges(): void {
            if (this.scope.formSection !== null && this.scope.formSection !== undefined) {
                // Dealing with a form section move
                if (this.scope.model.destinationForm === undefined ||
                    this.scope.model.destinationForm === null ||
                    this.scope.model.destinationStep === undefined ||
                    this.scope.model.destinationStep === null) {
                    alert("Please select both a destination form and step if you wish to move this form section.");
                } else {
                    // Remove from old Form and Step
                    var currentStep = Enumerable.from(this.scope.form.mySteps)
                        .single(i => i.id === this.scope.formSection.formStep_id);
                    currentStep.formSections.remove(this.scope.formSection);

                    var orderedFormSections = Enumerable.from(currentStep.formSections)
                        .orderBy(i => i.position)
                        .toArray();

                    for (let i = 0; i < orderedFormSections.length; i++) {
                        orderedFormSections[i].position = i;
                    }

                    // Add to new Form and Step
                    this.scope.model.destinationStep.formSections.push(this.scope.formSection);
                    this.scope.formSection.formStep_id = this.scope.model.destinationStep.id;

                    this.scope.formSection.position = this.scope.model.destinationStep.formSections.length - 1;

                    this.formService.saveAllChanges(() => {

                        this.formService.setupFormSchema(this.scope.form);

                        this.formService.saveAllChanges(() => {
                            this.formService.getFormConfiguration(this.scope.model.destinationForm.id).then(
                                (form) => {
                                    this.formService.setupFormSchema(form);
                                    this.formService.saveAllChanges(() => {
                                        var dto: Wars.Domain.Model.Dtos.FormChangeDto = {
                                            formSectionId: this.scope.formSection.id,
                                            formSectionObjectSchemaId: this.scope.formSection.objectSchema.id,
                                            originalFormId: this.scope.form.id,
                                            newFormId: this.scope.model.destinationForm.id
                                        };
                                        this.formService.performFormChangeUpdates(dto);
                                        this.dismissModal(true);
                                    });
                                });
                        });
                    });
                }
            } else {
                alert("This modal only supports moving a form section currently.");
                this.dismissModal(true);
            }
        }
    }
}

warsApp.registerController('FormChangeModalController',
    [
        '$scope', 'formSection', "form", 'processConfigId', 
        'formService', "processConfigurationService", 'close'
    ]
);